import { MenuItem, Select, ThemeProvider } from '@mui/material'
import { useAppSelector } from '~/app/hooks'
import { currentTheme, isDarkTheme } from '~/redux/features'
import { createCustomizedTheme, MenuProps } from '.'
import classNames from 'classnames/bind'
import styles from './EFSelect.module.scss'
import DOMPurify from 'dompurify'
import { EFTypography } from '../EFTypography'
import { EFSelectProps } from './EFSelect.model'
import { EFInputLabel } from '../EFInputLabel'

const cx = classNames.bind(styles)
export function CustomizedSelect(props: EFSelectProps) {
  const { label, name, data, value, onChange } = props
  const theme = useAppSelector(currentTheme)
  const isDark = useAppSelector(isDarkTheme)

  return (
    <div className='custom-field'>
      {label && (
        <EFInputLabel
          name={name}
          label={label}
        />
      )}
      <ThemeProvider theme={createCustomizedTheme(isDark)}>
        <Select
          {...props}
          value={value ? value.value : ''}
          onChange={onChange}
          labelId={name}
          id={name}
          MenuProps={{ ...MenuProps, ...props.MenuProps }}
          className={cx('select-field', theme)}
          displayEmpty
          sx={{
            '& fieldset': {
              top: 0,
              '& legend': { display: 'none' }
            }
          }}
        >
          {props.placeholder && (
            <MenuItem
              value={''}
              className={cx('menu-select-item', theme)}
              hidden={props.required}
            >
              <EFTypography color='secondary'>{props.placeholder}</EFTypography>
            </MenuItem>
          )}
          {data.map((item, index) => (
            <MenuItem
              className={cx('menu-select-item', theme)}
              key={index}
              value={item.value}
              sx={{ ' .Mui-selected': { backgroundColor: 'red !important' } }}
            >
              <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.name) }} />
            </MenuItem>
          ))}
        </Select>
      </ThemeProvider>
    </div>
  )
}
